import { createSlice } from '@reduxjs/toolkit';
import { analytics } from '../../utils/analytics';

export const STRAPI_ID = 'STRAPI';

const initialState = {
    isSubmitting: false,
    resource: null,
};

const slice = createSlice({
    name: `${STRAPI_ID}`,
    initialState,
    reducers: {
        getConsensusSummary: state => state,
        getConsensusSummaryCompleted: (state, { payload: resource }) => {
            state.resource = resource;
        },
        postConsensusSummary: (state) => {
            state.isSubmitting = true;
        },
        postConsensusSummaryCompleted: (state, { payload: setSubmissionStep }) => {
            analytics.trackAnalytics({ event: 'custom_submit_successful' });
            setSubmissionStep('submissionComplete');
            state.isSubmitting = false;
        },
        postConsensusSummaryFailed: (state) => {
            state.isSubmitting = false;
        },
        getPeerChallenge: state => state,
        getPeerChallengeCompleted: (state, { payload: resource }) => {
            state.resource = resource;
        },
    },
});

export const {
    getConsensusSummary,
    getConsensusSummaryCompleted,
    postConsensusSummary,
    postConsensusSummaryCompleted,
    postConsensusSummaryFailed,
    getPeerChallenge,
    getPeerChallengeCompleted,
} = slice.actions;

export const { reducer } = slice;
